// extracted by mini-css-extract-plugin
module.exports = {"root":"cards-with-popups-module--root--3b4ZW","cards":"cards-with-popups-module--cards--35rg7","card":"cards-with-popups-module--card--fZwIi"};